import { CheckCircleTwoTone } from "@ant-design/icons";
import { Modal, Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import React from "react";
import {
  DataImportSchema,
  DataImportSchema_dataImportSchema_properties,
} from "../../../../graphql/__generated_types__/DataImportSchema";

export type DataSchemaModalProps = {
  title: string;
  schemaInformation: DataImportSchema;
  handleClose: () => void;
};

const COLUMNS: ColumnsType<DataImportSchema_dataImportSchema_properties> = [
  { title: "Name", dataIndex: "name" },
  {
    title: "Data Type",
    dataIndex: "type",
  },
  {
    title: "Min Length",
    dataIndex: "minLength",
  },
  {
    title: "Max Length",
    dataIndex: "maxLength",
  },
  {
    title: "Format",
    dataIndex: "format",
  },
  {
    title: "Required",
    dataIndex: "required",
    render: (value) => <span>{value ? <CheckCircleTwoTone /> : ""}</span>,
  },
];

export const DataSchemaModal: React.FC<DataSchemaModalProps> = ({
  schemaInformation,
  title,
  handleClose,
}) => {
  return (
    <Modal
      centered
      title={title}
      closable={false}
      cancelButtonProps={{ style: { display: "none" } }}
      visible={true}
      okText="Ok"
      width={800}
      onOk={handleClose}
    >
      <div>
        <Table
          pagination={false}
          columns={COLUMNS}
          rowKey={(row) => row.name}
          dataSource={schemaInformation.dataImportSchema.properties}
        ></Table>
      </div>
    </Modal>
  );
};
